// ── Enter key navigation across actual-input fields ────────────
// Navigation order: down within the same month column, then first row of next month
$(document).on('keydown', '.actual-input', function (e) {
  if (e.key !== 'Enter') return;
  e.preventDefault();

  var $currentInput = $(this);
  var $currentRow   = $currentInput.closest('tr');
  var $tbody        = $currentRow.closest('tbody');
  var $allRows      = $tbody.find('tr');

  // Column index = position of this input within its row's actual-inputs
  var colIdx  = $currentRow.find('.actual-input').index($currentInput);
  var rowIdx  = $allRows.index($currentRow);
  var lastRow = $allRows.length - 1;

  if (rowIdx < lastRow) {
    // Move down to the same column in the next row
    $allRows.eq(rowIdx + 1).find('.actual-input').eq(colIdx).focus().select();
  } else {
    // Last row — move to first row of the next month column
    var $firstRowInputs = $allRows.first().find('.actual-input');
    var totalCols = $firstRowInputs.length;

    if (colIdx < totalCols - 1) {
      $allRows.first().find('.actual-input').eq(colIdx + 1).focus().select();
    } else {
      // All columns done — focus save button
      $('.btn-save').first().focus();
    }
  }
});

// Prevent form submit on Enter (except submit button)
$(document).on('keydown', '#actual-expense-form', function (e) {
  if (e.key === 'Enter' && !$(e.target).is('button, input[type=submit]')) {
    e.preventDefault();
  }
});